import styles from "./ResultCard.module.css"

const getValueFor = (value, label, hideModel) =>
{
    if (hideModel && ['model', 'estimate price'].includes(label))
        return '***'
    if (typeof value === 'object' && value != null)
        return <div>{JSON.stringify(value)}</div>
    if (value == null)
        return '---'
    return <pre>{value.toString()}</pre>
}

const ResultCard = ({data}) => {

    if (!data || !data?.documents) {
        return <div className={styles['container']}>
            <div className={styles['section-card']}>
                <div>Nenhum resultado pode ser extraído para este documento</div>
            </div>
        </div>
    }

    return (
        <div className={styles['container']}>
            <div className={styles['section-card']}>
                {data.documents.map((doc,index) => <div>
                    <h3>{doc.file_name}</h3>
                    <div className={styles['fields-section']}>
                        <div className={styles['fields-row']}>
                            <div className={styles['fields-name']}>document type:</div>
                            <div className={styles['fields-value']}>{doc.document_type}</div>
                        </div>
                        {doc.extracted_fields.map((field,findex)=> <div className={styles['fields-row']}>
                            <div className={styles['fields-name']}>{field.name}</div>
                            <div className={styles['fields-value']}>{getValueFor(field.value, field.label, false)}</div>
                        </div>)}
                    </div>
                </div>)}
            </div>

            <div className={styles['section-card']}>
                <div className={styles['fields-section']}>
                    {data.validation_result.map((inq,index) => <div className={styles['fields-row']}>
                        <div className={styles['fields-name']}>{inq.inquiry_id} - {inq.inquiry_text}</div>
                        <div className={styles['fields-value']}>
                            <div>{inq.validation_result? "TRUE":"FALSE"}</div>
                            <div>&nbsp;</div>
                            <div>{inq.annotation}</div>
                        </div>
                    </div>)}
                </div>
            </div>

            {data.prompt_response && <div className={styles['section-card']}>
                <div className={styles['fields-section']}>
                    <div className={styles['fields-row']}>
                        <div className={styles['fields-name']}>{data?.prompt}</div>
                        <div className={styles['fields-value']}>{data.prompt_response}</div>
                    </div>
                </div>
            </div>}
        </div>
    );
}


export default ResultCard;


